import React from 'react'
import CommonLayout from '../../../Components/CommonLayout/CommonLayout'
import FoodPage from './FoodPage'

const FoodDetails = () => {
    return(<>
        <div className="p-5 mx-auto">
        <CommonLayout />
        <FoodPage/>
        </div>
       </>)
}

export default FoodDetails